import React from "react";
import SeoPage from "../../components/SeoPage";
import RELATED from "../../data/related";
import { faqsByTopic } from "../../data/faqs";

export default function LightweightCsvEditor() {
    return (
        <SeoPage
            title="Lightweight CSV Editor — Fast, Minimal, Mobile-Ready"
            description="OpenCSV is a lightweight CSV editor under 200 KB. It opens instantly, runs on any device, and skips every feature you don't need."
            breadcrumbs={[{ label: "Home", href: "/" }, { label: "Lightweight CSV Editor" }]}
            eyebrow="/ feature"
            h1="A genuinely lightweight CSV editor"
            heroLead="Most 'lightweight' apps are still 100 MB downloads. OpenCSV is a web app that loads in under a second and uses less memory than a single browser tab full of news headlines."
            sections={[
                { heading: "What 'lightweight' actually means here",
                    bullets: [
                        "App weight: under 200 KB compressed (smaller than one Excel splash screen)",
                        "Open time: instant — no install, no launcher, no spinner",
                        "Memory: ~50 MB with a 50,000-row file open (Excel routinely uses 10× that)",
                        "Battery: doesn't pin a CPU core — your laptop fan stays quiet",
                        "Network: zero traffic for local files; only on Save / Share",
                    ],
                },
                { heading: "Why it stays small", body: "We deliberately said no to a long list of features: no formula engine, no pivot tables, no charts, no themes, no macros, no scripting, no plugin system. Each one would have doubled the app size. Instead, OpenCSV does five things really well — open, edit, search, save, share — and nothing else." },
                { heading: "Where lightweight wins",
                    sub: [
                        { heading: "Mobile data fixes", body: "On a phone, every megabyte of app size hurts: install time, battery, RAM. A lightweight web app means you can edit a CSV on the train without thinking about it." },
                        { heading: "Older hardware", body: "Got a 5-year-old Chromebook in the office for guests? OpenCSV runs perfectly on it. Excel would barely launch." },
                        { heading: "Embedded usage", body: "If you're a developer, you can iframe OpenCSV into an admin panel for non-technical staff to edit CSV exports — no app deployment needed." },
                    ],
                },
                { heading: "Tradeoffs we're upfront about",
                    body: "Lightweight isn't free. You give up:",
                    bullets: [
                        "No formulas (use Excel for math)",
                        "No charts (use Sheets for visuals)",
                        "No macros / scripting",
                        "No multiple-sheet files",
                    ],
                    callout: "If those tradeoffs aren't OK, OpenCSV isn't the right tool. If they are, it's by far the fastest way to work with CSV data."
                },
            ]}
            faqs={faqsByTopic("lightweight", "edit", "devices")}
            related={[RELATED.editor, RELATED.viewer, RELATED.fast, RELATED.privacy, RELATED.vs, RELATED.faq]}
        />
    );
}
